import { __assign, __awaiter, __generator } from "tslib";
import { getImageUrl } from '@wix/sdk/media';
import { BOOKINGS_APP_DEF_ID } from '@wix/wixstores-client-core';
import { SPECS } from '../../constants';
import { guidToInt } from '../../utils/guidToInt';
import { getCustomTextFields, getOptionsSelectionsValues } from './getLeanGQLCartFromCart';
export function getLeanGQLCartFromCartV1(currentCartService, siteStore, cart) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!(cart !== null && cart !== void 0)) return [3 /*break*/, 1];
                    _b = cart;
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, currentCartService.getCurrentCartV1()];
                case 2:
                    _b = (_c.sent());
                    _c.label = 3;
                case 3:
                    cart = _b;
                    if (!(((_a = cart.lineItems) === null || _a === void 0 ? void 0 : _a.some(function (lineItem) { var _a; return ((_a = lineItem.catalogReference) === null || _a === void 0 ? void 0 : _a.appId) === BOOKINGS_APP_DEF_ID; })) &&
                        !siteStore.experiments.enabled(SPECS.DontUseLineItemEnricherInCartAndCheckout))) return [3 /*break*/, 5];
                    return [4 /*yield*/, currentCartService.getCurrentCartGQL()];
                case 4: return [2 /*return*/, (_c.sent())];
                case 5: return [2 /*return*/, mapCartToLeanGQLCartModelV1(cart, siteStore.experiments.enabled(SPECS.FixImageOnTinyCart))];
            }
        });
    });
}
function mapLineItemToProductV1(lineItem, fixImageOnTinyCart) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var image = lineItem.image ? getImageUrl(lineItem.image) : undefined;
    var media = image
        ? {
            url: /* istanbul ignore next */ fixImageOnTinyCart ? (_a = image.id) !== null && _a !== void 0 ? _a : image.filename : image.filename,
            width: image.width,
            height: image.height,
            mediaType: 'PHOTO',
        }
        : { height: 0, width: 0, mediaType: 'PHOTO', url: '' };
    return {
        id: (_b = lineItem.catalogReference) === null || _b === void 0 ? void 0 : _b.catalogItemId,
        name: (_d = (_c = lineItem.productName) === null || _c === void 0 ? void 0 : _c.translated) !== null && _d !== void 0 ? _d : undefined,
        price: ((_e = lineItem.priceBeforeDiscounts) === null || _e === void 0 ? void 0 : _e.amount) ? Number(lineItem.priceBeforeDiscounts.amount) : 0,
        media: [media],
        weight: (_g = (_f = lineItem.physicalProperties) === null || _f === void 0 ? void 0 : _f.weight) !== null && _g !== void 0 ? _g : 0,
        productType: (_k = (_j = (_h = lineItem.itemType) === null || _h === void 0 ? void 0 : _h.preset) === null || _j === void 0 ? void 0 : _j.toLowerCase()) !== null && _k !== void 0 ? _k : (_m = (_l = lineItem.itemType) === null || _l === void 0 ? void 0 : _l.custom) === null || _m === void 0 ? void 0 : _m.toLowerCase(),
        customTextFields: getCustomTextFields((_o = lineItem.catalogReference) === null || _o === void 0 ? void 0 : _o.options),
    };
}
function mapCartToLeanGQLCartModelV1(cart, fixImageOnTinyCart) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var coupon = (_b = (_a = cart.appliedDiscounts) === null || _a === void 0 ? void 0 : _a.find(function (discount) { return discount.coupon; })) === null || _b === void 0 ? void 0 : _b.coupon;
    var appliedDiscounts = mapLineItemIdToRulesV1(cart.appliedDiscounts);
    return {
        cartId: cart._id,
        items: ((_c = cart.lineItems) !== null && _c !== void 0 ? _c : []).map(function (lineItem) {
            return mapLineItemToLeanLineItemModelV1(lineItem, appliedDiscounts[lineItem._id], fixImageOnTinyCart);
        }),
        convertedTotals: {
            itemsTotal: ((_d = cart.subtotal) === null || _d === void 0 ? void 0 : _d.convertedAmount) ? Number(cart.subtotal.convertedAmount) : undefined,
            formattedItemsTotal: (_e = cart.subtotal) === null || _e === void 0 ? void 0 : _e.formattedConvertedAmount,
            discount: ((_f = cart.discount) === null || _f === void 0 ? void 0 : _f.convertedAmount) ? Number(cart.discount.convertedAmount) : undefined,
            subTotal: ((_g = cart.subtotal) === null || _g === void 0 ? void 0 : _g.convertedAmount) ? Number(cart.subtotal.convertedAmount) : undefined,
            shipping: 0,
            tax: 0,
            total: ((_h = cart.subtotalAfterDiscounts) === null || _h === void 0 ? void 0 : _h.convertedAmount)
                ? Number(cart.subtotalAfterDiscounts.convertedAmount)
                : undefined,
        },
        convertedCurrencyFormat: { code: cart.conversionCurrency },
        buyerNote: (_j = cart.buyerNote) !== null && _j !== void 0 ? _j : null,
        appliedCoupon: coupon
            ? {
                couponId: coupon._id,
                code: coupon.code,
                name: coupon.code,
                convertedDiscountValue: (_k = cart.discount) === null || _k === void 0 ? void 0 : _k.formattedConvertedAmount,
            }
            : undefined,
    };
}
function mapLineItemToLeanLineItemModelV1(lineItem, appliedDiscounts, fixImageOnTinyCart) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    var fileType = (_b = (_a = lineItem.digitalFile) === null || _a === void 0 ? void 0 : _a.fileType) === null || _b === void 0 ? void 0 : _b.toLowerCase();
    var comparePrice = ((_c = lineItem.fullPrice) === null || _c === void 0 ? void 0 : _c.formattedConvertedAmount) !== ((_d = lineItem.price) === null || _d === void 0 ? void 0 : _d.formattedConvertedAmount)
        ? lineItem.fullPrice
        : undefined;
    var formattedPriceBeforeDiscount = ((_e = lineItem.priceBeforeDiscounts) === null || _e === void 0 ? void 0 : _e.formattedConvertedAmount) !== ((_f = lineItem.price) === null || _f === void 0 ? void 0 : _f.formattedConvertedAmount)
        ? (_g = lineItem.priceBeforeDiscounts) === null || _g === void 0 ? void 0 : _g.formattedConvertedAmount
        : '';
    var product = mapLineItemToProductV1(lineItem, fixImageOnTinyCart);
    return __assign(__assign({ cartItemId: guidToInt(lineItem._id), quantity: lineItem.quantity, inventoryQuantity: (_j = (_h = lineItem.availability) === null || _h === void 0 ? void 0 : _h.quantityAvailable) !== null && _j !== void 0 ? _j : null, productId: (_k = lineItem.catalogReference) === null || _k === void 0 ? void 0 : _k.catalogItemId, catalogAppId: (_l = lineItem.catalogReference) === null || _l === void 0 ? void 0 : _l.appId, optionsSelectionsValues: getOptionsSelectionsValues((_m = lineItem.descriptionLines) !== null && _m !== void 0 ? _m : [], product.customTextFields), product: product, sku: (_p = (_o = lineItem.physicalProperties) === null || _o === void 0 ? void 0 : _o.sku) !== null && _p !== void 0 ? _p : '', convertedPrices: {
            formattedPrice: (_q = lineItem.price) === null || _q === void 0 ? void 0 : _q.formattedConvertedAmount,
            formattedComparePrice: (_r = comparePrice === null || comparePrice === void 0 ? void 0 : comparePrice.formattedConvertedAmount) !== null && _r !== void 0 ? _r : '',
            formattedPriceBeforeDiscount: formattedPriceBeforeDiscount,
            totalPrice: ((_s = lineItem.lineItemPrice) === null || _s === void 0 ? void 0 : _s.convertedAmount) ? Number(lineItem.lineItemPrice.convertedAmount) : 0,
        }, comparePrice: (comparePrice === null || comparePrice === void 0 ? void 0 : comparePrice.amount) ? Number(comparePrice.amount) : 0, discountRules: appliedDiscounts ? appliedDiscounts.map(function (name) { return ({ name: name }); }) : [], urlPart: (_t = lineItem.url) === null || _t === void 0 ? void 0 : _t.split('/').pop(), digitalProductFileItems: fileType ? [{ fileType: fileType }] : [] }, product), { media: product.media[0] });
}
function mapLineItemIdToRulesV1(appliedDiscounts) {
    if (!appliedDiscounts) {
        return {};
    }
    return appliedDiscounts.reduce(function (acc, discount) {
        var _a;
        if (!discount.discountRule) {
            return acc;
        }
        (_a = discount.lineItemIds) === null || _a === void 0 ? void 0 : _a.forEach(function (lineItemId) {
            var _a;
            acc[lineItemId] = (_a = acc[lineItemId]) !== null && _a !== void 0 ? _a : [];
            acc[lineItemId].push(discount.discountRule.name.translated);
        });
        return acc;
    }, {});
}
//# sourceMappingURL=getLeanGQLCartFromCartV1.js.map